import React, { useState } from 'react';
import { login } from '../../utils/api';
import { useNavigate } from 'react-router-dom';

const LoginForm = () => {
    const [credentials, setCredentials] = useState({ username: '', password: '' });
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const res = await login(credentials);
        if (res.data.success) window.location.reload();
    };

    return (
        <div className='max-w-md mx-auto min-h-screen flex justify-center items-center'>
            <form onSubmit={handleSubmit} className=" p-8 bg-white shadow-md border">
                <h3 className='text-2xl mb-6 font-semibold'>
                    Login to Dashboard
                </h3>
                <input
                    type="text"
                    placeholder="Username"
                    value={credentials.username}
                    onChange={e => setCredentials({ ...credentials, username: e.target.value })}
                    className="border p-2 w-full mb-4"
                    required
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={credentials.password}
                    onChange={e => setCredentials({ ...credentials, password: e.target.value })}
                    className="border p-2 w-full mb-4"
                    required
                />
                <button type="submit" className="bg-blue-500 text-white p-2 w-full">Login</button>
            </form>
        </div>
    );
};

export { LoginForm };